<script lang="ts">
    import CN from "classnames";

    import BaseButton from "@components/Buttons/BaseButton.svelte";

    //Optional props
    export let ariaLabel: string | null = null;
    export let disabled = false;

    //Reactive Statement
    $: classes = CN("gw-rd-icon-btn", {
        "gw-rd-icon-btn--disabled": disabled,
    });
</script>

<BaseButton class={classes} {ariaLabel} on:click>
    <slot />
</BaseButton>

<style lang="postcss" global>
    .gw-rd-icon-btn {
        position: relative;
        display: flex;
        align-items: center;
        color: inherit;

        &--disabled {
            opacity: 0.4;
            pointer-events: none;
            user-select: none;
        }
    }
</style>
